import script from "./basic-hk-knowledge.vue?vue&type=script&lang=js&setup=true"
export * from "./basic-hk-knowledge.vue?vue&type=script&lang=js&setup=true"

import "./basic-hk-knowledge.vue?vue&type=style&index=0&id=423d3488&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423d3488"]])

export default __exports__